import { useState } from "react";
import "./style.css"
import { useDispatch } from "react-redux";
import { setMessage, setWait } from "../../redux";

const initForm = {
    subject: '',
    message: '',
    image: null,
};

function Contact() {
    const dispatch = useDispatch();
    const [form, setForm] = useState(null);

    const onSubmit = async (e) => {
        e.preventDefault();

        if (form.subject === '') {
            dispatch(setMessage('Merci de choisir le sujet de votre demande.'));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        if (form.message === '') {
            dispatch(setMessage('Merci de renseigner quelques mots dans "message".'));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        const token = sessionStorage.getItem("token");

        const formData = new FormData();
        formData.append("subject", form.subject);
        formData.append("message", form.message);

        if (form.image) {
            formData.append("image", form.image);
        }

        dispatch(setWait(1));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/contact`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        });
        const res = await req.json();
        dispatch(setWait(-1));

        dispatch(setMessage(
            req.status !== 200 ?
                res.message :
                'Votre message a bien été transmis, nous reviendrons vers vous si nécessaire.'
        ));

        setTimeout(() => {
            dispatch(setMessage());
            setForm(null);
        }, 2000);
    }

    if (!form) return (
        <button
            className="btn_contact"
            onClick={() => setForm(initForm)}
        >
            <i className="far fa-comment"></i>
        </button>
    );

    return (
        <div className="mdl_contact">
            <div className="overlay" onClick={() => setForm(null)} />

            <form onSubmit={onSubmit}>
                <button
                    type="button"
                    className="close_btn"
                    onClick={() => setForm(null)}
                >✕</button>

                <h2>Contact annuaire PSOA</h2>

                <p className="text">
                    Un bug, une question ou une suggestion ? <br />
                    N'hésitez pas à nous en faire part ci-dessous :
                </p>

                <div className="inp_form">
                    <label>Objet</label>
                    <select
                        value={form.subject}
                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    >
                        <option value=''>Choisir un sujet</option>
                        <option value='Bug du site'>Bug</option>
                        <option value='Question utilisateur'>Question</option>
                        <option value='Suggestion utilisateur'>Suggestion</option>
                        <option value='Correction du site'>Fautes d'orthographe</option>
                        <option value='Demande spécifique'>Autre</option>
                    </select>
                </div>

                <div className="inp_form">
                    <label>Message</label>
                    <textarea
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        placeholder="Décrivez votre demande..." 
                    />
                </div>

                <div className="inp_form">
                    <label>Ajouter une image</label>
                    <input
                        type="file"
                        onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
                    />
                </div>

                <button className="btn_submit">
                    Envoyer
                </button>
            </form>
        </div>
    )
}

export default Contact;